/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const showmore = () => {
  const btnShow = document.querySelector('.js-show-more-btns');
  if (btnShow) {
    btnShow.addEventListener('click', e => {
      const targetBtn = e.currentTarget.getAttribute('data-target');
      const items = document.querySelectorAll('.js-btn-items');
      items.forEach(el => {
        if (el.classList.contains(targetBtn)) {
          el.classList.add('is-active');
        }
      });
      e.currentTarget.style.display = 'none';
    });
  }
};

export default showmore;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/show-more.js